import Vue from "vue";
import UserGallery from './vue/views/users/gallery'
import UserChat from './vue/views/users/chat'
import PaymentCheckout from './vue/views/payment/checkout'

import Axios from "axios"

//config
Axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Axios.defaults.withCredentials = true;

Vue.component('payment-checkout', PaymentCheckout)
Vue.component('user-chat', UserChat)
Vue.component('user-gallery', UserGallery)

export default function() {
    if(document.querySelector('#app')) {
        document.querySelectorAll('#app').forEach(function( element ) {
            new Vue({
                el: element,
            });
        });
    }

    document.querySelectorAll('.loader.-main').forEach(function(node) {
        node.remove();
    });
}
